import { Component, OnInit } from '@angular/core';
import { GenerateFormType } from 'src/app/shared/generate-form/generate-form-type.enum';
import { GenerateForm } from 'src/app/shared/generate-form/generate-form';
import { Validators } from '@angular/forms';
import { CustomEmailValidator } from 'src/app/shared/validators/custom-email.validator';
import { PasswordValidator } from 'src/app/shared/validators/password.validator';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { finalize } from 'rxjs/operators';
import { LocalstorageService } from 'src/app/core/services/localstorage/localstorage.service';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/core/services/notification/notification.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  showLoading: boolean;
  col = 'col-sm-12';
  formStructure: GenerateForm[] = [
    {
      type: GenerateFormType.TEXT,
      id: 'email',
      placeholder: 'E-mail',
      validator: [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'), CustomEmailValidator.validate]
    },
    {
      type: GenerateFormType.PASSWORD,
      id: 'password',
      placeholder: 'Senha',
      validator: [Validators.required, Validators.minLength(5), PasswordValidator.validate]
    }
  ];

  constructor(
    private authService: AuthService,
    private localstorageService: LocalstorageService,
    private router: Router,
  ) { }

  ngOnInit() {
  }

  returnForm(e) {
    this.showLoading = true;
    this.authService.login(e.data.email, e.data.password).pipe(
      finalize(() => {
        this.showLoading = false;
      })).subscribe(result => {
        this.localstorageService.save({ token: result.AccessToken });
        this.router.navigate(['/perfil']);
      });
  }
}
